import { render, staticRenderFns } from "./LeaderScore.vue?vue&type=template&id=5146dd25&"
import script from "./LeaderScore.vue?vue&type=script&lang=js&"
export * from "./LeaderScore.vue?vue&type=script&lang=js&"
import style0 from "./LeaderScore.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports